/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "59bbdfe036aa9f51a0e7709f956d3ecc30e8659d";
